import { Icon, IconProps } from "@chakra-ui/react";

const PersonFillIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 16 31" {...props}>
      <path
        d="M10.1522 8.83602H13.3341C13.7752 8.83634 14.2095 8.94607 14.5978 9.15537C14.9862 9.36468 15.3166 9.66703 15.5594 10.0354C15.8023 10.4037 15.95 10.8265 15.9894 11.2659C16.0287 11.7053 15.9585 12.1476 15.785 12.5533L8.74175 28.9927C8.57173 29.3864 8.2713 29.7094 7.89103 29.9076C7.51075 30.1057 7.07384 30.1668 6.65381 30.0805C6.23378 29.9943 5.85627 29.7661 5.58479 29.4342C5.31332 29.1023 5.16445 28.687 5.16324 28.2582V15.9504L2.57895 15.8703C1.88691 15.8472 1.23096 15.556 0.749705 15.0582C0.268455 14.5603 -0.000384371 13.8949 4.12479e-07 13.2024V2.66788C4.12479e-07 1.96031 0.28108 1.28173 0.781404 0.781404C1.28173 0.281079 1.96031 0 2.66788 0L7.48429 0C8.19186 0 8.87044 0.281079 9.37077 0.781404C9.87109 1.28173 10.1522 1.96031 10.1522 2.66788V8.83602Z"
        fill="#FEA368"
      />
    </Icon>
  );
};

export default PersonFillIcon;
